import { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../components/img/logo.jpeg";

const AdminLoginAccess = () => {
  const { email } = useParams(); // get email from path param
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (email) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "info",
        title: "Logging into customer account...",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });

      loginByEmail(email);
    } else {
      Swal.fire({
        icon: "error",
        title: "No email found",
        text: "Cannot proceed without an email parameter in the URL.",
      });
      setLoading(false);
    }
  }, [email]);

  const loginByEmail = async (emailParam) => {
    try {
      const response = await axios.post(`${baseurl}loginByEmail`, { email: emailParam });

      const {
        token,
        userId,
        email: userEmail,
        organization_id,
        organization_name,
        org_2,
        org_2_name,
        org_3,
        org_3_name,
        org_4,
        org_4_name,
        org_5,
        org_5_name,
        org_6,
        org_6_name,
        org_7,
        org_7_name,
        org_8,
        org_8_name,
        org_9,
        org_9_name,
        org_10,
        org_10_name,
      } = response.data;

      // Save in localStorage
      localStorage.setItem("auth_token", token);
      localStorage.setItem("adminID", userId);
      localStorage.setItem("admin_email", userEmail);
      localStorage.setItem("organization_id", organization_id);
      localStorage.setItem("default", organization_id);
      localStorage.setItem("organization_name", organization_name);

      const otherOrgs = [
        { id: org_2, name: org_2_name },
        { id: org_3, name: org_3_name },
        { id: org_4, name: org_4_name },
        { id: org_5, name: org_5_name },
        { id: org_6, name: org_6_name },
        { id: org_7, name: org_7_name },
        { id: org_8, name: org_8_name },
        { id: org_9, name: org_9_name },
        { id: org_10, name: org_10_name },
      ].filter((org) => org.id);

      localStorage.setItem("other_org", JSON.stringify(otherOrgs));

      // 🔥 Add expiry timestamp (10 min from now)
      const expiryTime = new Date().getTime() + 10 * 60 * 1000;
      localStorage.setItem("session_expiry", expiryTime);

      // 🔥 Setup auto-logout timer
      setTimeout(() => {
        localStorage.clear();
        Swal.fire({
          icon: "warning",
          title: "Session Expired",
          text: "Your impersonation session has expired. Please login again.",
        }).then(() => {
          navigate("/"); // redirect to login/home
        });
      }, 10 * 60 * 1000);

      // Redirect after login
      navigate("/dashboard");
    } catch (error) {
      console.error("Login failed:", error.response?.data?.message || error.message);
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div>
        <div className="text-center">
          <img src={logo} className="img-fluid logo" alt="Bosplan Logo" />
        </div>

        <div className="mb-3 text-center">
          <h3 className="text-dark">Logging in as Customer</h3>
          <p className="text-muted">Impersonating user account</p>
        </div>

        <div className="card p-4" style={{ maxWidth: "400px", width: "100%" }}>
          {loading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status"></div>
              <p className="mt-3">Logging into {email}...</p>
            </div>
          ) : (
            <p className="text-center">Logged in as {email}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLoginAccess;
